import { render, staticRenderFns } from "./Classes.vue?vue&type=template&id=7451d83d&"
import script from "./Classes.vue?vue&type=script&lang=js&"
export * from "./Classes.vue?vue&type=script&lang=js&"
import style0 from "./Classes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports